import * as React from 'react';

import { cn } from '@shared';
import { DialogContent } from './Dialog';

/**
 * A dialog that keeps the desktop modal treatment and becomes an app-like
 * full-screen surface on narrow viewports. Complex workflows use this shell
 * so their body can scroll independently from a persistent header/footer.
 */
export const ResponsiveDialogContent = React.forwardRef<
  React.ElementRef<typeof DialogContent>,
  React.ComponentPropsWithoutRef<typeof DialogContent>
>(function ResponsiveDialogContent({ className, ...props }, ref) {
  return (
    <DialogContent
      ref={ref}
      className={cn(
        '!h-[100dvh] !max-h-[100dvh] !w-screen !max-w-none !rounded-none !border-x-0 !p-0 !flex !flex-col !gap-0 overflow-hidden',
        'sm:!h-auto sm:!max-h-[92vh] sm:!w-full sm:!rounded-lg sm:!border-x sm:!p-6 sm:!grid sm:!gap-4',
        '[&>button]:z-30 [&>button]:right-4 [&>button]:top-4 [&>button]:hidden sm:[&>button]:block',
        className,
      )}
      {...props}
    />
  );
});

ResponsiveDialogContent.displayName = 'ResponsiveDialogContent';
